// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateTeasePopupContent_wrapper__QC4n0"};